import DOMPurify from 'dompurify';

const decodeHtmlEntities = (str: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = str;
  return textarea.value;
};

export default (string?: string): string => {
  if (!string) return '';
  const decoded = decodeHtmlEntities(string);

  const result = DOMPurify.sanitize(decoded, {
    ALLOWED_TAGS: [
      'a',
      'abbr',
      'acronym',
      'address',
      'area',
      'article',
      'aside',
      'b',
      'bdi',
      'bdo',
      'big',
      'blink',
      'blockquote',
      'br',
      'caption',
      'center',
      'cite',
      'code',
      'col',
      'colgroup',
      'data',
      'dd',
      'del',
      'dfn',
      'dir',
      'div',
      'dl',
      'dt',
      'em',
      'figcaption',
      'figure',
      'font',
      'footer',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'header',
      'hr',
      'i',
      'img',
      'ins',
      'kbd',
      'label',
      'li',
      'listing',
      'main',
      'mark',
      'marquee',
      'menu',
      'menuitem',
      'meter',
      'nav',
      'nobr',
      'ol',
      'p',
      'pre',
      'q',
      'rb',
      'rp',
      'rt',
      'rtc',
      'ruby',
      's',
      'samp',
      'section',
      'small',
      'spacer',
      'span',
      'strike',
      'strong',
      'sub',
      'sup',
      'table',
      'tbody',
      'td',
      'tfoot',
      'th',
      'thead',
      'time',
      'tr',
      'tt',
      'u',
      'ul',
      'var',
      'wbr',
    ],
    ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'class', 'src', 'alt', 'width', 'height', 'style'],
    ALLOW_DATA_ATTR: true,
  });

  return result;
};
